const SORT = {
  RATING_HIGH: "rating_desc",
  RATING_LOW: "rating_asc",
  DATE_NEW: "date_desc",
  DATE_OLD: "date_asc"
}
export default SORT
